import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import InputName from "../../common/Input/InputName";
 
const AddUpdateBank = ({
  showModal,
  setModalVisible,
  handleChange,
  modalAction,
  formData,
  handleAddOrUpdateBank,
  accountType,
  handleSelectChange,
  setInputError,
  submitLoading,
  inputError
}) => {
  return (
    <Modal
      centered
      show={showModal}
      onHide={() => setModalVisible(false)}
      size="md"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {modalAction === "create" ? "Add Bank" : "Update Bank"}
        </h5>
        <button
          type="button"
          className="btn-close"
         
          onClick={() => {
            setModalVisible(false);
            setInputError({
              name: "",
            });
          }}
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleAddOrUpdateBank}>
          <div className="row">
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Account Type</label>
                <Select
                  name="accountType"
                  value={
                    formData.accountType
                      ? {
                        value: formData.accountType,
                        label: formData.accountTypeName,
                      }
                      : null
                  }
                  placeholder="Select Account Type"
                  onChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "accountType")
                  }
                  options={accountType?.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                />
              </div>
            </div>
 
            <label className="col-form-label">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Account Name"
              className="form-control"
            />
 
            {inputError?.name && (
              <small className="text-danger">
                {inputError.name}
              </small>
            )}
            <div className="col-xl-12">
              <div className="form-group d-flex align-items-center">
                <label htmlFor="status" className="col-form-label me-3">
                  Status:
                </label>
                {["Active", "Inactive", "Deleted"].map((status) => (
                  <div className="form-check me-3" key={status}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id={status.toLowerCase()}
                      value={status}
                      checked={formData.status === status}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={status.toLowerCase()}
                    >
                      {status}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              // onClick={() => setModalVisible(false)}
              onClick={() => {
                setModalVisible(false);
                setInputError({
                  name: "",
                });
              }}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitLoading}
            >
              {submitLoading ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
              ) : null}
              {submitLoading
                ? "Please wait..."
                : modalAction === "create"
                  ? "Create"
                  : "Update"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddUpdateBank;
 
 